import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { queryKeys } from "../api/queryKeys";
import { isAuthenticated } from "../../services/auth";

interface Customer {
  cd_cliente: number;
  nr_dv_cliente: number;
  cnpj: number;
  ds_cliente: string;
}

export const useCustomers = (enabled: boolean = true) => {
  return useQuery<Customer[]>({
    queryKey: queryKeys.customers,
    queryFn: async () => {
      const response = await api.get("clientes");
      return response.data;
    },
    enabled: enabled && isAuthenticated(),
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
};
